import React, { useState, useEffect, useContext, createContext } from "react";

// APIs
import api from "../services/api";

import { useAuth } from "./useAuth";

export const dictionaryContext = createContext();

function useDictionaryProvider() {
  const [dictionaryMap, setDictionaryMap] = useState({});
  const { user } = useAuth();

  const fetchDictionaryValues = async () => {
    try {
      const response = await api.getDictionaryValuesGrouped();
      if (response.status === 200) {
        setDictionaryMap(response.data);
      }
    } catch (error) {
      console.error("Error fetching dictionary values:", error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchDictionaryValues();
    }
  }, [user]);

  function getDictionaryTypeValues(type) {
    if (!dictionaryMap[type]) return [];
    return Object.entries(dictionaryMap[type])
      .map(([id, obj]) =>
        typeof obj === "object" && obj !== null && "value" in obj
          ? { id: parseInt(id), value: obj.value, hardcoded: !!obj.hardcoded }
          : { id: parseInt(id), value: obj, hardcoded: false }
      )
      .sort((a, b) => a.value.localeCompare(b.value));
  }

  function getDictionaryTypeValuesObject(type) {
    if (!dictionaryMap[type]) return [];
    return Object.entries(dictionaryMap[type])
      .map(([id, obj]) =>
        typeof obj === "object" && obj !== null ? { id: parseInt(id), ...obj } : { id: parseInt(id), value: obj, extraData: {} }
      )
      .sort((a, b) => a.value.localeCompare(b.value));
  }

  function getDictionaryValue(type, id) {
    if (!dictionaryMap[type]) return "";
    const obj = dictionaryMap[type][id];
    if (typeof obj === "object" && obj !== null && "value" in obj) {
      return obj.value;
    }
    return obj || "";
  }

  function getDictionaryValueObject(type, id) {
    if (!dictionaryMap[type]) return {};
    const obj = dictionaryMap[type][id];
    if (typeof obj === "object" && obj !== null) {
      return obj;
    }
    return { value: obj };
  }

  return {
    dictionaryMap,
    getDictionaryTypeValues,
    getDictionaryTypeValuesObject,
    getDictionaryValue,
    getDictionaryValueObject,
    refreshDictionaries: fetchDictionaryValues,
  };
}

export function ProvideDictionary({ children }) {
  const values = useDictionaryProvider();
  return <dictionaryContext.Provider value={values}>{children}</dictionaryContext.Provider>;
}

export const useDictionary = () => {
  return useContext(dictionaryContext);
};
